<template>
  <vue-recaptcha
    v-show="showRecaptcha"
    ref="vueRecaptcha"
    :sitekey="siteKey"
    @verify="recaptchaVerified"
    @expire="recaptchaExpired"
    @fail="recaptchaFailed"
  >
  </vue-recaptcha>
</template>

<script>
import vueRecaptcha from "vue3-recaptcha2";

export default {
  name: "App",
  components: {
    vueRecaptcha,
  },
  data() {
    return {
      showRecaptcha: true,
      siteKey: "6LeWnjMlAAAAABcLkOkNdEJtlpAvzB65b4_kuNml",
      //local: 6LdZVDYlAAAAAFusTmJy_ugSTQb1LBx5Ps9oFOGq
      //live & staging: 6LeWnjMlAAAAABcLkOkNdEJtlpAvzB65b4_kuNml
    };
  },
  methods: {
    recaptchaVerified(response) {
      this.$emit("valid", response);
      //console.log(response)
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() {
      console.error("Captch Failed 🛠️");
    },
  },
};
</script>
